import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import type { ReactNode } from 'react'
import type { ConfirmationIconVariant } from './ConfirmationModalIcon'
import { ConfirmationModalIcon } from './ConfirmationModalIcon'
import {
  confirmationBodyCompactSx,
  confirmationHeadlineLargeSx,
  confirmationPrimaryFullWidthButtonSx,
} from './confirmationModalStyles'

type Props = Readonly<{
  headline: string
  bodyLines?: readonly [string] | readonly [string, string]
  body?: ReactNode
  primaryLabel: string
  iconVariant?: ConfirmationIconVariant
  onPrimary: () => void
  panelTestId?: string
  primaryTestId?: string
}>

/** Same layout as AlertStatusModal 4418:10043 — for full-page auth cards (no Dialog). */
export function AlertStatusPanel({
  headline,
  bodyLines,
  body,
  primaryLabel,
  iconVariant = 'alert',
  onPrimary,
  panelTestId = 'alert-status-panel',
  primaryTestId = 'alert-status-primary',
}: Props) {
  return (
    <Box
      data-testid={panelTestId}
      sx={{
        width: '100%',
        maxWidth: 448,
        bgcolor: '#ffffff',
        borderRadius: '16px',
        boxShadow:
          '0px 10px 7.5px rgba(0, 0, 0, 0.1), 0px 4px 3px rgba(0, 0, 0, 0.1)',
        pt: '30px',
        pb: '42px',
        px: '32px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <ConfirmationModalIcon variant={iconVariant} />

      <Typography component="h1" sx={{ ...confirmationHeadlineLargeSx, mt: '24px' }}>
        {headline}
      </Typography>

      {body ??
        bodyLines?.map((line) => (
          <Typography
            key={line}
            sx={{
              ...confirmationBodyCompactSx,
              mt: line === bodyLines[0] ? '16px' : 0,
              maxWidth: 400,
            }}
          >
            {line}
          </Typography>
        ))}

      <Button
        variant="contained"
        fullWidth
        onClick={onPrimary}
        data-testid={primaryTestId}
        sx={{ ...confirmationPrimaryFullWidthButtonSx, mt: '32px' }}
      >
        {primaryLabel}
      </Button>
    </Box>
  )
}
